//import Pikaday from 'pikaday';
import moment from 'moment';
import { vf, typeArray } from './elements.js';



/**
***  Page loading  */
const loadingWrapper = document.getElementById('loadingWrapper');
window.onload = function(){
  // ない場合はなにもしない
  if( !loadingWrapper ){ return; }
  setTimeout(function() {
    loadingWrapper.classList.add('disabled');
  }, 100);
}



/**
***  モーダルウインドウを開く  */
export const modalOpenExec = (contents) => {
  vf.verifyWrapper.classList.add(vf.verifyOpenClass);
  document.body.style.overflow = 'hidden';
  vf.verifyContents.innerHTML = contents;
}



/**
***  モーダルウインドウを閉じる  */
export const modalCloseExec = () => {
  vf.verifyWrapper.classList.remove(vf.verifyOpenClass);
  document.body.style.overflow = '';
  vf.verifyContents.innerHTML = '';
}



// エラーメッセージの出力
export const errorMessage = (str) => {
  return `<span class="error">${str}</span>`;
}



// オブジェクトの空判定
export const isObjEmpty = (obj) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}



/**
***  カレンダーの入力値をクリアするイベント  */
(function(){
  const removeBtn = document.querySelectorAll('.delete-calendar');
  // ない場合はなにもしない
  if( !removeBtn ){ return; }

  for( let btn of removeBtn ){
    btn.addEventListener('click', function(){
      const target = this;
      // クリアするカレンダーのINPUT要素（マークアップの構造を変えないように！）
      const calendar = target.previousElementSibling.previousElementSibling;
      // 入力値をクリア
      calendar.value = '';

      // 強制的にイベントを発生させる
      const newEvent = new Event('change', {bubbles:true});
      calendar.dispatchEvent(newEvent);
    });
  }
}());



/**
***  inputNumOnly  */
(function(){
  const elements = document.querySelectorAll( '.js-inputNumOnly' );
  // ない場合はなにもしない
  if( ! elements ){ return }

  elements.forEach( elm => {
    elm.addEventListener('keyup', changeEvt(elm));
    elm.addEventListener('focus', changeEvt(elm));
  });

  elements.forEach( elm => {
    elm.addEventListener('change', function(){
      const data = this.value;
      const hankaku = data.replace(/[０-９. ]/g,function(s){
        return String.fromCharCode(s.charCodeAt(0)- 65248);
      });
      this.value = hankaku;
    });
  });

  function changeEvt(e){
    let old = e.value;
    let v, str, othverVal, maxVal2;

    return function(){
      v = e.value;
      str = this.value;
      // 全角数字は半角数字へ変換, 数字以外の文字列は削除
      str = str.replace(/[^0-9 ０-９]+/, '');

      e.addEventListener('blur', function(){
        let str = this.value;
        str = str.replace(/[^0-9 ０-９]+/, '');
        this.value = str;
      });

      if (v !== str){
        e.value = str;
      }

      if ( old != v){
        old = v;
      }
    };
  }
}());



// /**
// ***  pikaday.config
// ***  @params id element
// */
// window.pikaday = ( $elm, $day = 0, $nameArray = [] ) => {

//   const minDate = daysLater($day);

//   new Pikaday({
//     field: $elm,
//     format: 'YYYY-M-D',
//     showMonthAfterYear: true,
//     toString(date, format) {
//       return moment(date).format('YYYY-MM-DD');
//     },
//     minDate: new Date(minDate),
//     i18n: {
//       previousMonth : '前月',
//       nextMonth     : '次月',
//       months        : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
//       weekdays      : ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
//       weekdaysShort : ['日','月','火','水','木','金','土']
//     },
//     yearSuffix: '年',
//     disableDayFn: function(date) {
//       // 日曜日を除外
//       if( date.getDay() === 0 ){
//         return true
//       }

//       // 指定した日付を除外
//       const chkDate = moment(date).format('YYYY-MM-DD');

//       // 祝日を除外
//       if( holidaysArr.includes(chkDate) ){
//         return true
//       }

//       // 配列で指定
//       if( $nameArray.length > 0 ){
//         if( getValuesArray($nameArray).includes(chkDate) ){
//           return true
//         }
//       }
//     }
//   }); // end of Pikaday

//   // 日後
//   function daysLater(day){
//     let dt = new Date();
//     dt.setDate( dt.getDate() + day );
//     // 日曜日なら1日足す
//     if( dt.getDay() === 0 ){
//       dt.setDate( dt.getDate() + 1 );
//     }
//     return dt.getFullYear() + '-' + ( '00' + (dt.getMonth() + 1) ).slice(-2) + '-' + ( '00' + dt.getDate()).slice(-2);
//   }
// }

// // 祝日データを取得する
// //
// global.holidaysArr = [];
// // 取得したい JSON がある URL を変数へ代入
// let requestURL = 'https://holidays-jp.github.io/api/v1/date.json';
// // HTTP リクエストを作成するのに、new を使って XMLHttpRequest から新しいリクエストオブジェクトをつくる
// let request = new XMLHttpRequest();
// // 新しいリクエストを開始
// request.open('GET', requestURL);
// // XHR オブジェクトがサーバーから返されるデータを判断
// request.responseType = 'json';
// // リクエストを送信
// request.send();
// // リクエストに対するレスポンス (response プロパティから取得できます) を 変数へ代入
// request.onload = function(){
//   const holidays = request.response;
//   Object.keys(holidays).forEach( function(elm){
//     holidaysArr.push(elm);
//   });
// }



/**
*** 日付の正当性チェック
**/
window.isDateValid = (date) => {
  return moment(date).isValid();
};



/**
*** 曜日を取得
**/
window.getWeekNum = (date) => {
  return moment(date).day();
};



/**
*** yubinbango.js
**/
(function(){
var t=[],YubinBango;!function(YubinBango){var n=function(){function n(t,n){if(void 0===t&&(t=""),this.URL="https://yubinbango.github.io/yubinbango-data/data",this.g=[null,"北海道","青森県","岩手県","宮城県","秋田県","山形県","福島県","茨城県","栃木県","群馬県","埼玉県","千葉県","東京都","神奈川県","新潟県","富山県","石川県","福井県","山梨県","長野県","岐阜県","静岡県","愛知県","三重県","滋賀県","京都府","大阪府","兵庫県","奈良県","和歌山県","鳥取県","島根県","岡山県","広島県","山口県","徳島県","香川県","愛媛県","高知県","福岡県","佐賀県","長崎県","熊本県","大分県","宮崎県","鹿児島県","沖縄県"],t){var e=t.replace(/[０-９]/g,function(t){return String.fromCharCode(t.charCodeAt(0)-65248)}),r=e.match(/\d/g),o=r.join(""),i=this.h(o);i?this.i(i,n):n(this.j())}}return n.prototype.h=function(t){if(7===t.length)return t},n.prototype.j=function(t,n,e,r,o){return void 0===t&&(t=""),void 0===n&&(n=""),void 0===e&&(e=""),void 0===r&&(r=""),void 0===o&&(o=""),{k:t,region:n,l:e,m:r,o:o}},n.prototype.p=function(t){return t&&t[0]&&t[1]?this.j(t[0],this.g[t[0]],t[1],t[2],t[3]):this.j()},n.prototype.q=function(t,n){window.$yubin=function(t){return n(t)};var e=document.createElement("script");e.setAttribute("type","text/javascript"),e.setAttribute("charset","UTF-8"),e.setAttribute("src",t),document.head.appendChild(e)},n.prototype.i=function(n,e){var r=this,o=n.substr(0,3);return o in t&&n in t[o]?e(this.p(t[o][n])):void this.q(this.URL+"/"+o+".js",function(i){return t[o]=i,e(r.p(i[n]))})},n}();YubinBango.Core=n}(YubinBango||(YubinBango={}));var n=["Japan","JP","JPN","JAPAN"],e=["p-region-id","p-region","p-locality","p-street-address","p-extended-address"],YubinBango;!function(YubinBango){var t=function(){function t(){this.s()}return t.prototype.s=function(){var n=this,e=document.querySelectorAll(".h-adr");[].map.call(e,function(e){if(n.t(e)){var r=e.querySelectorAll(".p-postal-code");r[r.length-1].addEventListener("keyup",function(e){t.prototype.u(n.v(e.target.parentNode))},!1)}})},t.prototype.v=function(t){return"FORM"===t.tagName||t.classList.contains("h-adr")?t:this.v(t.parentNode)},t.prototype.t=function(t){var e=t.querySelector(".p-country-name"),r=[e.innerHTML,e.value];return r.some(function(t){return n.indexOf(t)>=0})},t.prototype.u=function(t){var n=this,e=t.querySelectorAll(".p-postal-code");new YubinBango.Core(this.A(e),function(e){return n.B(t,e)})},t.prototype.A=function(t){return[].map.call(t,function(t){return t.value}).reduce(function(t,n){return t+n})},t.prototype.B=function(t,n){var r=[this.C,this.D];r.map(function(r){return e.map(function(e){return r(e,t,n)})})},t.prototype.C=function(t,n,e){if(e){var r=n.querySelectorAll("."+t);[].map.call(r,function(t){return t.value=""})}},t.prototype.D=function(t,n,e){var r={"p-region-id":e.k,"p-region":e.region,"p-locality":e.l,"p-street-address":e.m,"p-extended-address":e.o},o=n.querySelectorAll("."+t);[].map.call(o,function(n){return n.value+=r[t]?r[t]:""})},t}();YubinBango.MicroformatDom=t}(YubinBango||(YubinBango={})),document.addEventListener("DOMContentLoaded",function(){new YubinBango.MicroformatDom},!1);
}());



/**
*** フォーム要素の type を取得する
**/
export function getType(obj)
{
  if( obj.length && obj.type === undefined ){
    for( let i = 0; i < 2; i++ ){
      return obj[i].type;
    }
  }
  return obj.type;
}



/**
*** 通常の name  OR group の name を取得する
**/
export function getName(group, name)
{
  // group に含まれているかチェック 含まれていれば group の name が返ってくる
  const isGroup = getGroupProp(group, name);

  return isGroup ? isGroup : name;
}



/**
*** group に含まれているかチェック
**/
export function getGroupProp(obj, name)
{
  let property = false;
  if( ! isObjEmpty(obj) ){
    for( const prop in obj ){
      // group に含まれているか
      const reg = new RegExp('\\b' + name + '\\b');
      if( obj[prop].match(reg) !== null ){
        property = prop;
      };
    }
  }
  return property;
}



/**
*** 要素が NodeList か
**/
export function isNodeList(el)
{
  return Object.prototype.toString.call(el) === '[object RadioNodeList]';
}



/**
*** エラーメッセージを表示する要素を取得する
**/
export function getErrorElement( elementName, group )
{
  // 通常の name  OR group の name を取得する
  const name = getName(group, elementName);

  return document.getElementById( name + '_error' );
}



/**
*** rule に含まれているか？
**/
export function inRules(name)
{
  return name in Validations.rules;
}



/**
*** 値がobject型か判定する
**/
export function isObject(value)
{
  return value !== null && typeof value === 'object';
}



/**
*** 指定した name の配列の value を取得して配列として返す
*** @used Pikaday
**/
function getValuesArray( nameArray )
{
  if( nameArray.length <= 0 ) return;
  let arr = [];
  nameArray.forEach( name => {
    arr.push( vivaForm[name].value );
  });
  return arr;
}
